import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBellOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBellOff"><Path d="M2.74999 1.68933L1.68933 2.74999L4.93774 5.9984C4.33925 6.99515 3.94432 8.13254 3.81319 9.35646L2.99999 17.5H16.4393L21.25 22.3107L22.3107 21.25L2.74999 1.68933Z" fill="currentColor"/><Path d="M21 17.5H20.6821L6.92893 3.7468C8.33246 2.64891 10.097 1.99999 12 1.99999C16.2077 1.99999 19.7385 5.17263 20.1867 9.35647L21 17.5Z" fill="currentColor"/><Path d="M7.416 19C8.18756 20.7659 9.94964 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19H7.416Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBellOff;
